export const BREAKPOINT_MOBILE_PX = 500;
export const BREAKPOINT_TABLET_PX = 768;
export const BREAKPOINT_TABLET_LARGE_PX = 1050;
export const BREAKPOINT_DESKTOP_PX = 1300;
export const BREAKPOINT_DESKTOP_LARGE_PX = 1500;
